import React from 'react'
import { Route } from 'react-router-dom'

//Redirect to unauthenticated app
const RedirectUnauthenticated = ({
	path,
	location,
	isAuthenticated,
	willAuthenticate,
	component: Component,
}: Props) =>
{
	if (!isAuthenticated && !willAuthenticate){
		window.location = `${process.env.REACT_APP_UNAUTH_PREVIEW_URL}/${location.pathname}`
	} else if(isAuthenticated){
		return(	
			<Route
		 		exact
		 		path={path}
		 		render={(props) => {
		 			 if (typeof window.ga === 'function') {
						    window.ga('set', 'page',  location.pathname + location.search)
						    window.ga('send', 'pageview')
  						}
		 			return <Component {...props} /> }}
			/>
			
		)
 
	}
	else return null

}

export default RedirectUnauthenticated
